import React, { createContext, useContext, useState } from "react";

// Create the context
const CartContext = createContext();

// Custom hook to use the Cart context
export const useCart = () => useContext(CartContext);


export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);


  const addToCart = (product, option, quantity) => {
    setCart((prevCart) => {
      const existingItemIndex = prevCart.findIndex(
        (item) =>
          item.product._id === product._id

      );
      if (existingItemIndex >= 0) {
        const updatedCart = [...prevCart];
        updatedCart[existingItemIndex].quantity = quantity;
        return updatedCart;
      }


      return [...prevCart, { product, option, quantity }];
    });
  };

  const updateOptionInCart = (product, option) => {
    setCart((prevCart) => {
      const existingItemIndex = prevCart.findIndex(
        (item) =>
          item.product._id === product._id

      );
      if (existingItemIndex >= 0) {
        const updatedCart = [...prevCart];
        updatedCart[existingItemIndex].option = option;
        return updatedCart;
      }


      // return [...prevCart, { product, option, quantity }];
    });
  };

  // Remove item from cart
  const removeFromCart = (productId, optionId) => {
    setCart((prevCart) =>
      prevCart.filter(
        (item) =>
          !(item.product._id === productId
            //   && item.option.option_id === optionId
          )
      )
    );
  };

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateOptionInCart }}>
      {children}
    </CartContext.Provider>
  );
};
